import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getDynamicWorkflowStatus } from 'state/dynamic/selectors';
import { getStaticWorkflowStatus, WorkFlowStatus } from 'state/selectors';
import { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

import { TradeWaySwitch } from './TradeWaySwitch';

function componentForStatus(status: WorkFlowStatus) {
  switch (status) {
    case 'QUOTED':
    case 'QUOTED_TRADABLE':
      return TradeWaySwitch;
    case 'INITIALIZED':
    case 'READY':
    case 'QUOTING':
    case 'STREAMING':
    case 'STREAMING_INITIATED':
    case 'STREAMING_TRADABLE':
    case 'STREAM_EXPIRED':
    case 'QUOTED_PREVIOUSLY':
    case 'REJECTED':
    case 'TRADE_AUTH_REJECTED':
    case 'TRADING':
    case 'BOOKING':
    case 'TRADED':
    case 'STREAMING_TRADED':
    case 'BOOKED':
    case 'ERROR':
    case 'UNDEFINED':
      return null;
    default:
      throw new Error(`status is not supported ${status}`);
  }
}

export interface TradeWayProps {
  workspaceType: QuoteWorkspaceType;
  tabId: string;
}

export const TradeWay: FC<TradeWayProps> = ({ workspaceType, tabId }) => {
  const status = useSelector(getWorkflowStatus(workspaceType, tabId));
  const Comp = componentForStatus(status);

  return (
    Comp !== null && (
      <GenericErrorBoundary key={tabId}>
        <Comp e2e="side-panel-tradeway" tabId={tabId} workspaceType={workspaceType} />
      </GenericErrorBoundary>
    )
  );
};

function getWorkflowStatus(workspaceType: QuoteWorkspaceType, tabId: string) {
  return (state: AppState) =>
    workspaceType === 'static' ? getStaticWorkflowStatus(state, tabId) : getDynamicWorkflowStatus(state, tabId);
}
